import { IFile } from "@/types/upload";
import { FileUploader } from "react-drag-drop-files";
import { useUpload } from "@/hooks/useUpload";

import { useTranslation } from "react-i18next";
import React from "react";

type Props = {
  file?: IFile;
  fileTypes: string[];
  disabled?: boolean;
  onChange?: (file: IFile) => void;
  children?: React.ReactNode;
  pure?: boolean;
};

const AssetUploader = ({
  file,
  onChange,
  fileTypes,
  disabled,
  children,
  pure,
}: Props) => {
  const upload = useUpload();
  const { t } = useTranslation();

  const handleChange = async (file: File) => {
    const uploadedFile = await upload?.upload(file);
    if (uploadedFile) {
      onChange && onChange(uploadedFile);
    }
  };

  return (
    <div
      className={`${pure ? "" : "flex flex-col items-center justify-center text-center cursor-pointer border border-gray-300 rounded-md p-6 min-h-[15.4rem] rounded-full h-full w-full"} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}>
      <FileUploader
        classes={`${pure ? "" : "flex flex-col items-center justify-center gap-2 min-h-[15.4rem] h-full w-full rounded-full"}`}
        disabled={disabled}
        multiple={false}
        handleChange={handleChange}
        types={fileTypes}>
        {file ? (
          <img
            src={file.url || file.file}
            alt="Uploaded file"
            className="w-full h-[18.9rem] rounded-md object-cover object-center"
          />
        ) : children ? (
          children
        ) : (
          <div className="flex flex-col items-center justify-center p-7">
            <button
              type="button"
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-opacity">
              {t("common.add_file")}
            </button>
          </div>
        )}
      </FileUploader>
    </div>
  );
};

export default AssetUploader;
